<template>
  <el-dialog
    v-if="visible"
    v-el-dialog-drag
    show-close
    append-to-body
    destroy-on-close
    visible
    :width="width"
    title=""
    :close-on-click-modal="false"
    @close="close"
  >
    <coord-picker
      style="height:450px"
      bottom="0px"
      :city="city"
      :address="address"
      :location="coordOptions.location"
      @change="onChange"
    />
    <span slot="footer">
      <el-button @click="close()">取消</el-button>
      <el-button type="primary" @click="confirm">确定</el-button>
    </span>
  </el-dialog>
</template>
<script>
const coordOptions = () => ({
  address: '',
  location: '',
  longitude: '',
  latitude: ''
})
export default {
  props: {
    visible: Boolean,
    city: String,
    address: {
      type: String,
      default: ''
    },
    location: {
      type: String,
      default: ''
    },
    longitude: {
      type: [String, Number],
      default: ''
    },
    latitude: {
      type: [String, Number],
      default: ''
    },
    width: {
      type: String,
      default: '1000px'
    }
  },
  data() {
    return {
      coordOptions: coordOptions()
    }
  },
  mounted() {
    this.setLocation()
  },
  methods: {
    setLocation() {
      this.coordOptions.location = this.location
      if (!this.location) {
        this.coordOptions.location = [this.longitude, this.latitude]
          .filter(Boolean)
          .join(',')
      }
    },
    onChange(val) {
      const { location, address, lng, lat } = val
      this.coordOptions = {
        address,
        location,
        longitude: lng,
        latitude: lat
      }
    },
    confirm() {
      this.$emit('update:visible', false)
      if (this.coordOptions.location) {
        this.$emit('update:address', this.coordOptions.address)
        this.$emit('update:location', this.coordOptions.location)
        this.$emit('update:longitude', this.coordOptions.longitude)
        this.$emit('update:latitude', this.coordOptions.latitude)
        this.$emit('confirm', this.coordOptions)
      }
    },
    close() {
      this.$emit('update:visible', false)
      this.coordOptions = coordOptions()
      this.$emit('close')
    }
  }
}
</script>
